import { CheckCircle2, Search } from "lucide-react";
import { MobileEntregaCard } from "./MobileEntregaCard";
import { MobileOrdemControls } from "./MobileRotaBar";

// Lista de cards (com controles de ordem da rota nas ativas) + estados vazios.
export function MobileEntregasList({ filtered, total, ativosOrdenados, expanded, onToggleExpanded, data, unreadMap, flowBusy, rota, actions }) {
  const { lookup, formas, formasByEmpresa } = data;
  return (
    <>
      {filtered.length === 0 && total > 0 && (
        <div className="text-center py-10 text-muted-foreground" data-testid="mobile-empty-filtered">
          <Search className="w-10 h-10 mx-auto mb-2 text-orange-400" />
          <p className="font-semibold">Nada encontrado</p>
          <p className="text-xs mt-1">Ajuste a busca ou os filtros acima.</p>
        </div>
      )}
      {total === 0 && (
        <div className="text-center py-16 text-muted-foreground">
          <CheckCircle2 className="w-12 h-12 mx-auto mb-3 text-emerald-500" />
          <p>Nenhuma entrega atribuída a você hoje.</p>
        </div>
      )}
      {filtered.map((it) => {
        const isCollapsed = expanded[it.id] === undefined ? it.status === "concluida" : !expanded[it.id];
        const ativoIdx = ativosOrdenados.findIndex((x) => x.id === it.id);
        return (
          <div key={it.id} className="space-y-2">
            {ativoIdx >= 0 && ativosOrdenados.length > 1 && (
              <MobileOrdemControls id={it.id} ordem={it.ordem ?? ativoIdx + 1} etaMin={it.eta_min} isFirst={ativoIdx === 0} isLast={ativoIdx === ativosOrdenados.length - 1}
                busy={rota.rotaBusy} onUp={() => rota.moverOrdem(it.id, -1)} onDown={() => rota.moverOrdem(it.id, 1)} />
            )}
            <MobileEntregaCard
              it={it}
              lookup={lookup}
              formas={formasByEmpresa[it.empresa_id] || formas}
              unread={unreadMap[it.id]}
              expanded={expanded[it.id]}
              flowBusy={flowBusy?.entregaId === it.id ? flowBusy : null}
              onToggle={() => onToggleExpanded(it.id, isCollapsed)}
              onOpenChat={actions.openChat}
              onChangeFormaPgto={actions.changeFormaPgto}
              onSetStatus={actions.setStatus}
              onConfirmarRecebimento={actions.askConfirmarRecebimento}
            />
          </div>
        );
      })}
    </>
  );
}
